import React, { useState, useEffect } from 'react';

const CountdownTimer = ({ targetDate, customColor }) => {
  let difference = Date.parse(targetDate) - Date.now();
  const calculateTimeLeft = () => {
    difference = Date.parse(targetDate) - Date.now();
    let timeLeft = {};

    if (difference > 0) {
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60),
      };
    } else {
      timeLeft = { days: 0, hours: 0, minutes: 0, seconds: 0 };
    }

    return timeLeft;
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(timer);
  }, [targetDate]);

  return (
    <div style={{ display: 'flex', justifyContent:'center', gap: '10px', fontSize: '24px', fontFamily: 'DM Sans, sans-serif', fontWeight: 600, color: customColor ? customColor : '#0a1f3b', marginBottom: '10px' }}>
      {difference > 0?
      <>
      <div>Hurry!! Offer expires in: </div>
      <div><span>{timeLeft.days}</span>d</div>
      <div><span>{timeLeft.hours}</span>h</div>
      <div><span>{timeLeft.minutes}</span>m</div>
      <div><span>{timeLeft.seconds}</span>s</div>
      </>
      : <><div>Sorry! Offer has expired now.</div></>
    }
    </div>
  );
};

export default CountdownTimer;